import { createElement } from 'react';
import { func } from 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import { b as buttonPropTypes, c as buttonDefaultProps } from '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import 'reakit/Navigation';
import '../Navigation/styled.js';
import '../chunk-18be6601.js';
import '../Navigation/index.js';
import '../chunk-5c9bbccf.js';
import 'reakit/Popover';
import '../Popover/PopoverContainer.js';
import '../Popover/styled.js';
import '../Popover/PopoverHide.js';
import '../Popover/PopoverClose.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Popover/PopoverPopover.js';
import '../Popover/PopoverShow.js';
import '../Popover/PopoverToggle.js';
import '../chunk-8dd1e1d3.js';
import 'reakit/Divider';
import '../Divider/styled.js';
import '../Divider/index.js';
import '../Popover/index.js';
import { MenuButton as MenuButton$1 } from './styled.js';
import './MenuContext.js';
import MenuTrigger from './MenuTrigger.js';

var menuButtonPropTypes = _objectSpread({}, buttonPropTypes, {
  onClick: func
});

var menuButtonDefaultProps = _objectSpread({}, buttonDefaultProps);

var MenuButton = function MenuButton(_ref) {
  var props = _extends({}, _ref);

  return createElement(MenuButton$1, _extends({
    use: MenuTrigger
  }, props));
}; // @ts-ignore


var C = MenuButton;
export default C;
export { MenuButton, menuButtonDefaultProps, menuButtonPropTypes };